// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"54d73558","381":"2af5efd0","411":"26ffb7ea","447":"ff9481c9","453":"ed3810f9","938":"2026120b"}[chunkId] + ".chunk.js";
};